import React from "react";
import { FaSort } from "react-icons/fa";
import { ArrowUp, ArrowDown } from "lucide-react";
import Dropdown from "./DropDown";

const SortDropdown = ({ value, onChange, options, label = "Sort by", className = "" }) => {
  const [open, setOpen] = React.useState(false);

  

  return (
    <div className={`relative group ${className}`}>
      <Dropdown label={label} icon={FaSort}>
        {(close) => (
        <ul className="absolute right-0 mt-2 py-2 min-w-[220px] bg-white border rounded-lg shadow-lg z-20">
          {options?.map((opt) => {
            const asc = opt?.key;
            const desc = `-${opt?.key}`;

            return (
              <li
                key={opt?.key}
                className={`px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center justify-between ${value?.includes(asc)
                    ? "bg-blue-50 text-blue-600 font-medium"
                    : ""
                  }`}
              >
                <span onClick={() => {onChange(asc); close();}}>{opt?.label}</span>

                <div className="flex items-center gap-2">
                  <button
                    className={`text-xs ${value === asc ? "text-blue-600" : "text-gray-400"
                      }`}
                    onClick={() => {onChange(asc); close();}}
                    title="Ascending"
                  >
                    <ArrowUp className="w-4 h-4" />
                  </button>

                  <button
                    className={`text-xs ${value === desc ? "text-blue-600" : "text-gray-400"
                      }`}
                    onClick={() => {onChange(desc); close();}}
                    title="Descending"
                  >
                    <ArrowDown className="w-4 h-4" />
                  </button>
                </div>
              </li>
            );
          })}

          <li
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-500 text-sm"
            onClick={() => onChange("")}
          >
            Clear sort
          </li>
        </ul>
        )}
      </Dropdown>
    </div>
  );
};

export default SortDropdown;